import SaveButton from "@/components/button/save-button";
import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { InlineSearchInput } from "@/components/form/inline-search-input";
import { SelectablePill } from "@/components/form/selectable-pill";
import { PageTitleComponent } from "@/components/page-title";
import { RecreatePlanAlert } from "@/features/settings/components/recreate-plan-alert";
import { useAllergies } from "@/hooks/features/use-allergies";
import { useToast } from "@/hooks/ui/use-toast";
import { IonSkeletonText, useIonRouter } from "@ionic/react";
import { useState } from "react";

export default function SettingFoodPreferenceAllergiesPage() {
  const navigation = useIonRouter();
  const [isOpen, setIsOpen] = useState(false);
  const { showSuccess } = useToast();
  const {
    allergySet,
    selectedAllergies,
    setAllergySet,
    setSelectedAllergies,
    handleSubmit,
    isUpdating,
    isLoading,
    sortedAllergyList,
  } = useAllergies(() => {
    setIsOpen(true);
  });

  const handleRecreatePlan = () => {
    setIsOpen(false);
    showSuccess("Recreate plan successful");
    navigation.goBack();
  };

  const handleCancel = () => {
    setIsOpen(false);
    navigation.goBack();
  };

  if (isLoading) {
    return <IonSkeletonText animated />;
  }
  return (
    <ProfilePageContainer className="overflow-y-auto no-scrollbar pb-16">
      <PageTitleComponent
        title="Any allergies?"
        description="Please select any allergies you have from the list below. If your allergy is not listed, feel free to add it."
        className="mt-2 mb-6 w-full"
      />

      <div className="w-full flex flex-col gap-8 flex-1">
        <InlineSearchInput
          label="Add"
          onSubmit={(value) => {
            if (allergySet.has(value)) {
              return;
            }
            setAllergySet((prev) => new Set(prev).add(value));
            setSelectedAllergies((prev) => new Set(prev).add(value));
          }}
        />
        <div className="grid grid-cols-2 gap-4">
          {sortedAllergyList.map((allergy) => (
            <SelectablePill
              key={allergy}
              label={allergy}
              selected={selectedAllergies.has(allergy)}
              onClick={() => {
                if (selectedAllergies.has(allergy)) {
                  setSelectedAllergies((prev) => {
                    const next = new Set(prev);
                    next.delete(allergy);
                    return next;
                  });
                } else {
                  setSelectedAllergies((prev) => new Set(prev).add(allergy));
                }
              }}
            />
          ))}
        </div>
        <SaveButton
          text="Save"
          position="fixed"
          onSave={handleSubmit}
          disabled={isUpdating}
        />
      </div>
      <RecreatePlanAlert
        isOpen={isOpen}
        onCancel={handleCancel}
        onConfirm={handleRecreatePlan}
      />
    </ProfilePageContainer>
  );
}
